module.exports = __webpack_public_path__ + "img/img4.30a8f4a6.png";